import { Component } from '@angular/core';
import { Manufacturer } from 'src/app/models/manufacturer.model';
import { Model } from 'src/app/models/model.model';
import { ManufacturersService } from 'src/app/services/manufacturers/manufacturers.service';
import { ModelsService } from 'src/app/services/models/models.service';
import { ActivatedRoute, Router } from '@angular/router';
@Component({
  selector: 'app-models-list',
  templateUrl: './models-list.component.html',
  styleUrls: ['./models-list.component.css'],
})
export class ModelsListComponent {
  dtoptions: DataTables.Settings = {};
  models: Model[] = []
  manufacturers: Manufacturer[] = []

  constructor(
    private modelsService: ModelsService,
    private manufacturersService: ManufacturersService,
    private router: Router
  ) { }

  navigate(TId){
    console.log(TId);
    var id = btoa(TId.toString())
    this.router.navigate(['/component/models/edit/' + id]);
  }

  ngOnInit(): void {
    let loggedInuserRole = JSON.parse(atob(sessionStorage.getItem('currentUser')!));
    if (loggedInuserRole.role == 'Standard User' || loggedInuserRole.role == 'Internal User' || loggedInuserRole.role == 'Regional User') {
      this.logout();
    }
    this.dtoptions = {
      pagingType: 'full_numbers'
    };
    this.manufacturersService.getAllManufacturers().subscribe({
      next: (manufacturers) => {
        this.manufacturers = manufacturers;
        
      },
      error: (response) => {
        console.log(response);
      },
    });


    this.modelsService.getAllModel()
      .subscribe({
        next: (models) => {
          this.models = models;
          
        },
        error: (response) => {
          console.log(response);

        }
      })
  }
  logout() {
    sessionStorage.clear();
    this.router.navigate(['login']);
  }
}
